import Vector from "../../model/math/Vector";
import Sprite from "../../model/sprite/Sprite";
import Projection from "../../Projection";
import { Settings } from "../../Settings";

export default class SkillRenderer {
    constructor() {
        /**
         * @constant
         * @type {Vector}
         */
        this.screenCoordinate = new Vector(0, 0);
    }

    /**
     * @abstract
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     */
    renderSkill(context, projection) {
    }

    /**
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     * @param {Sprite} sprite
     * @param {Vector} canvasCoordinate The canvas coordinate.
     */
    renderSprite(context, projection, sprite, canvasCoordinate) {
        if (!sprite) {
            return;
        }

        // canvas origin: top left corner. y-coordinate increases downwards.

        const spriteSize = sprite.getSize();
        //////const scaledSize = spriteSize * projection.zoom;

        const scaledSize = Settings.tile.size * projection.zoom;

        // const spriteSize = sprite.getSize(); // Use the actual sprite size instead of the fixed 16px size that most sprites use.
        // this.scaledSize = this.spriteSize * projection.zoom;

        context.drawImage(sprite.getImage(),
            sprite.spriteX, sprite.spriteY,          // coords of sprite in sheet (top left corner)
            spriteSize, spriteSize,                  // width/height of sprite
            canvasCoordinate.x, canvasCoordinate.y,  // canvas coords to render sprite (top left corner)
            scaledSize, scaledSize);                 // width/height of rendered sprite
    }

}